import React from "react";
import Countdown from "../bond-wheel/Countdown";
import { PENDING_ROUND_WARN_SECONDS } from "../../utils/bondDrawPendingExpiry";

const BondDrawPendingExpiryHint = ({ deadline, secondsLeft }) => {
  if (deadline == null || secondsLeft == null || secondsLeft <= 0) return null;

  const tone =
    secondsLeft > 0 && secondsLeft <= PENDING_ROUND_WARN_SECONDS ? "lock" : "live";

  return (
    <div className="bdraw-expiry-meta" role="status" aria-live="polite">
      <Countdown deadline={deadline} size="hero" tone={tone} />
    </div>
  );
};

export default BondDrawPendingExpiryHint;
